import React, { useEffect, useState } from 'react';
import API from "libs/api";
import { Modal, Button } from 'semantic-ui-react';
import { INPUT } from "components/cmp_form/cmp_form";
import ICON from "components/cmp_icon/cmp_icon";



export default function CMP_CONTACT_UPDATE({ id, onOpen, onClose, onRefresh }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [ var_data, set_data ] = useState([]);
    const [ var_processing, set_processing ] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        if (onOpen && id) {
            get_contact();
        }
    }, [ onOpen, id ]);



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_contact(){

        set_processing('processing');

        try {
            let results = await API_get_contact();
            set_data(results === undefined ? {} : results);
            set_processing('inactive');
        } catch (e) {
            set_processing('error');
            console.log(e);
        }
    }

    async function put_contact() {

        set_processing('processing');

        try {
            await API_put_contact();
            set_processing('inactive');
            onRefresh();
            onClose();
        } catch (e) {
            set_processing('error');
            console.log(e);
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_contact(){
        return API.get('admin-providers', '/get-provider-contact/' + id);
    }

    function API_put_contact(){
        return API.put('admin-providers', '/put-provider-contact', { body: var_data});
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onChange_input(event){
        let data = {...var_data};
        data[event.target.name] = event.target.value;
        set_data(data);
    }

    function onClick_update(){
        put_contact();
    }

    function onClick_cancel(){
        onClose();
    }



    // RENDER APP ======================================================================================================

    return (
        <Modal
            dimmer={'inverted'}
            onClose={onClose}
            open={onOpen}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            id='cmp_contact_update'>
            <div className='icon__wrapper'>
                <div className='icon'>
                    <ICON name='profile_female_1' className='icon' alt='contact icon'/>
                </div>
            </div>
            <div className="modal__header">
                <div className='text--md bold'>Update contact</div>
            </div>

            <div className='modal__content'>

                <div className='field__wrapper'>
                    <div className='field__label text--sm bold'>Contact type</div>
                    <div className='buttongroup'>
                        <div className='buttongroup__item active'>Primary</div>
                        <div className='buttongroup__item'>Other</div>
                    </div>
                </div>

                <INPUT
                    errors={[]}
                    label='Email'
                    name='email'
                    onChange={onChange_input}
                    placeholder=''
                    value={var_data.email || null}
                />

                <INPUT
                    errors={[]}
                    label='Phone'
                    name='phone'
                    onChange={onChange_input}
                    placeholder=''
                    value={var_data.phone || null}
                />

                <INPUT
                    errors={[]}
                    label='Name'
                    name='name'
                    onChange={onChange_input}
                    placeholder=''
                    value={var_data.name || null}
                />
            </div>

            <div className='modal__footer'>
                <Button className='primary' onClick={onClick_update}>Update</Button>
                <Button className='secondary' onClick={onClick_cancel}>Cancel</Button>
            </div>
        </Modal>
    );
}